<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron @click="$router.back()"/>
                {{ $t('health.recipe.glucoRecipes') }}
              </h1>
            </div>
          </grid-col>
        </grid-row>
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="recipeTable"
              :data="fetchData"
              sort-by="name"
              sort-order="asc"
              :show-caption="false"
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <table-column
                show="id"
                :hidden="true"
                :filterable="false"
                data-type="boolean">
              </table-column>
              <table-column
                show="name"
                :label="$t('health.patient.name')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-on:click="viewRecipe(row)"
                    :icon="icon.view"
                    class="table-iconset-icon"/>
                </template>
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-on:click="toggleFavourite(row)"
                    :icon="row.liked ? icon.heartFilled : icon.heart"
                    :class="{ liked: row.liked }"
                    class="table-iconset-icon"/>
                </template>
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>
      </div>
      <recipe-detail-modal
        v-if="selectedRecipe"
        :recipe="selectedRecipe"
        @close="onRecipeModalClose"
      />
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
import Chevron from '@/components/shared/Chevron';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faEye, faHeart, faList } from '@fortawesome/pro-regular-svg-icons';
import { faHeart as faHeartFilled } from '@fortawesome/pro-solid-svg-icons';
import api from 'BRAND/api/recipe';
import { mapGetters } from 'vuex';
import RecipeDetailModal from 'BRAND/components/nutritionPlan/RecipeDetailModal';

export default {
  name: 'RecipeListNutri',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    FontAwesomeIcon,
    Chevron,
    RecipeDetailModal
  },
  data () {
    return {
      recipes: [],
      breadcrumb: [
        {link: '/workspace', name: this.$t('menu.workspace')},
        {link: '/recipe', name: this.$t('health.recipe.title'), disabled: true}
      ],
      icon: {
        view: faEye,
        heart: faHeart,
        heartFilled: faHeartFilled,
        list:faList
      },
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      },
      selectedRecipe: null
    };
  },
  computed: {
    ...mapGetters([
      'getLanguageCode'
    ]),
    getBreadcrumb () {
      return this.breadcrumb;
    },
    getRecipes () {
      return this.recipes;
    }
  },
  mounted () {
    this.requestRecipes();
  },
  watch:{
    'tableState.page'(newPage, oldPage){
      if(newPage !== oldPage){
        this.loadFavoritesForCurrentPage();
      }
    }
  },
  methods: {
    fetchData ({page, filter, sort}) {
      const tablePage = pagination.createPage(
        this.getRecipes,
        this.tableState,
        ['name'],
        this.tablePageSize,
        {page, filter, sort});
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    requestRecipes () {
      const languageCode = this.getLanguageCode;
      api.getRecipes(this, languageCode)
        .then((response) => {
          this.recipes = response;
          this.$refs.recipeTable.refresh();
          this.loadFavoritesForCurrentPage();
        })
        .catch((error) => console.error(error));
    },
    loadFavoritesForCurrentPage () {
      const start = (this.tableState.page - 1) * this.tablePageSize;
      const end = start + this.tablePageSize;
      const pageRecipes = this.recipes.slice(start, end);

      pageRecipes.forEach((recipe) => {
        if (recipe.liked === undefined) {
          api.isFavorite(this, recipe.id)
            .then((isFav) => {
              this.$set(recipe, 'liked', isFav);
            })
            .catch(() => {
              this.$set(recipe, 'liked', false);
            });
        }
      });
    },
    viewRecipe (row) {
      alert(this.$t('health.recipe.recipePreviewInfo'));
      api.getRecipeDetail(this, row.id, this.getLanguageCode)
        .then((data) => {
          this.selectedRecipe = data;
        })
        .catch((error) => console.error(error));
    },
    onRecipeModalClose () {
      this.selectedRecipe = null;
    },
    toggleFavourite (row) {
      const recipe = this.recipes.find(r => r.id === row.id);
      if (row.liked) {
        api.removeFavorite(this, row.id)
          .then(() => {
            this.$set(recipe, 'liked', false);
            this.$refs.recipeTable.refresh();
          })
          .catch((error) => console.error(error));
      } else {
        api.addFavorite(this, row.id)
          .then(() => {
            this.$set(recipe, 'liked', true);
            this.$refs.recipeTable.refresh();
          })
          .catch((error) => console.error(error));
      }
    }
  }
};
</script>

<style lang="scss">
@import "src/stylesheets/variables";

#header {
  display: inline-block;
  width: 100%;
  line-height: 1rem;
}
.header-title {
  float: left;
}
.header-add-button-icon {
  font-size: 3rem;
  color: $secondary;
}
.like-button {
  background: none;
  border: none;
  padding: 0;
  margin-left: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
}

.like-button:hover {
  transform: scale(1.1);
}

.liked {
  color: $primary
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/recipe/RecipeListNonEditable.vue